import React from 'react';
import { Redirect } from 'react-router-dom';

export default function PrivacyPolicy() {
  return <Redirect to="/privacy.pdf" />;
}
